import type { RateUnderlying } from 'models/underlying/rate';
import { FC } from 'react';

export const Rate: FC<RateUnderlying> = ({ bloombergTickerCode, reutersCode }) => (
  <>
    {bloombergTickerCode && (
      <>
        <dt>BLOOMBERG CODE:</dt>
        <dd>{bloombergTickerCode}</dd>
      </>
    )}

    {reutersCode && (
      <>
        <dt>RIC CODE:</dt>
        <dd>{reutersCode}</dd>
      </>
    )}
  </>
);
